/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-02-19 13:48:32
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-07-06 11:18:01
 * @FilePath: \vue-hepha-order\src\views\product\queryConfig\PlanListQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const PlanListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            key:'sku',
            type:'select',   
            allowClear:true,
            width:'230px',
            placeholder:'product.sku',
            options:[],
        },
        {
            key:'source_po',
            type:'input',   
            allowClear:true,
            width:'230px',
            placeholder:'plan.sourcePo',
        },
        {
            key:'process_code',
            type:'input',   
            allowClear:true,
            width:'230px',
            placeholder:'plan.processCode',
        },
        {
            key:'factory',
            type:'input',   
            allowClear:true,
            width:'230px',
            placeholder:'plan.factory',
        },
        {
            key:'record_date',
            type:'dateRange',   
            allowClear:true,
            width:'230px',
            placeholder:'plan.recordYear',
        },
    ]
}

const RecordListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            key:'sku',
            type:'select',   
            allowClear:true,
            width:'230px',
            placeholder:'product.sku',
            options:[], 
        },
        {
            key:'process_code',
            type:'input',   
            allowClear:true,
            width:'230px',
            placeholder:'plan.processCode',
        },
        {
            key:'batch_id',
            type:'input',   
            allowClear:true,
            width:'230px',
            placeholder:'plan.versionCode',
        }
    ]
}

const AddForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'plan.recordYear',//年份
            key:'record_year',
            type:'yearDate',   
            allowClear:true,
            required:true,
            disabled:false,
            width:'420px',
        },
        {
            name:'plan.recordWeek', // 周别
            key:'record_date',
            type:'weekDate',   
            allowClear:true,
            required:true,
            disabled:false,
            width:'420px',
        },
    ]
}

PlanListQuery.formField.forEach(item=>{
    PlanListQuery.formData[item.key] = ''
})

AddForm.formField.forEach(item=>{
    AddForm.formData[item.key] = ''
})

RecordListQuery.formField.forEach(item=>{
    RecordListQuery.formData[item.key] = ''
})

export {
    PlanListQuery,
    AddForm,
    RecordListQuery
}